import type { Rule } from 'antd/es/form';
import { Decimal } from 'decimal.js';

export function buildPercentageInputRules({ isRequired }: { isRequired?: boolean }): Rule[] {
    return [
        {
            // Only for asterisk on UI, actual validation for isRequired happens in validator below
            ...(isRequired ? { required: true } : {}),
            async validator(_, value: Decimal) {
                // `null` signals an invalid input (e.g. unparseable text from PercentageInput) and
                // is always rejected as malformed. `undefined` means the field is empty: rejected
                // with a "required" message when isRequired, otherwise left valid.
                if (value === null) {
                    throw new Error('Enter valid percentage');
                }

                if (isRequired && !Decimal.isDecimal(value)) {
                    throw new Error('Percentage is required');
                }
            },
        },
        {
            async validator(_, value: Decimal) {
                if (!Decimal.isDecimal(value)) {
                    return;
                }

                if (value?.lt(0)) {
                    throw new Error('Percentage must be 0 or greater');
                }
            },
        },
        {
            async validator(_, value: Decimal) {
                if (!Decimal.isDecimal(value)) {
                    return;
                }

                if (value?.gt(100)) {
                    throw new Error('Percentage must not exceed 100');
                }
            },
        },
    ];
}
